// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__73PVw","title":"Info_title__q6oMa","links":"Info_links__3SA48","link":"Info_link__mOppK","logo":"Info_logo__3pCrC"};